import { render, staticRenderFns } from "./DataStrats.vue?vue&type=template&id=c14ad9aa&"
import script from "./DataStrats.vue?vue&type=script&lang=js&"
export * from "./DataStrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports